import {StatConsentGlobal} from "./StatConsentGlobal";

export class StatConsentGlobalResult {
    [configId: string]: StatConsentGlobal;
}
